const GUEST_LINK_REGEX = /^\/join\/b-\w+\/\w+$/;

export const isGuestLinkPath = (path) => GUEST_LINK_REGEX.test(path);

export const isGuestInAllowedRoute = (referrer) =>
  referrer === 'apps' || referrer === 'dashboard' || referrer.startsWith('join/b-');

export const pathRequiresAuthentication = (path) =>
  path !== '/' && path !== '/login' && !isGuestLinkPath(path) && !path.includes('/login-sso');
